<script lang="ts">
    import Icon from '@iconify/svelte'

    import { gettext as _ } from 'hydria/services/gettext'

    interface Props {
        showDragAndDrop?: boolean;
        showCheckbox?: boolean;
    }

    let { showDragAndDrop = false, showCheckbox = true }: Props = $props();
</script>

<style>
    .handle {
        display: flex;
        height: 100%;
        align-items: center;
        font-size: 1.5em;
        color: white;
        padding: 0 0.25em;
    }
    .card {
        /* Pour les coins ronds sur le "handle" */
        overflow: hidden;
    }
    .el {
        margin-right: 1.5rem;
        white-space: nowrap;
        display: block;
    }
</style>

<div class="card mt-3">
    <div class="row g-0">
        <div class="col-auto bg-primary">
            <div class="handle">
                <Icon inline icon="mdi:notebook" />
            </div>
        </div>
        <div class="col">
            <div class="card-body">
                <div class="card-text"><small class="text-muted">{$_('Légende')}</small></div>
                {#if showDragAndDrop}
                    <span class="el"><Icon inline icon="mdi:drag-horizontal-variant" />&#x2009;:&#x2009;{$_('Ordonnez les documents en glissant avec la sourie.')}</span>
                    <span class="el"><Icon inline icon="mdi:undo" />&#x2009;:&#x2009;{$_('Annuler le changement d’ordre.')}</span>
                    <span class="el"><Icon inline icon="mdi:content-save" />&#x2009;:&#x2009;{$_('Sauvegarder l’ordre.')}</span>
                {/if}
                {#if showCheckbox}
                    <span class="el"><Icon inline icon="mdi:checkbox-blank-outline" />&#x2009;:&#x2009;{$_('Le document n’est pas publié.')}</span>
                    <span class="el"><Icon inline icon="mdi:checkbox-marked-outline" />&#x2009;:&#x2009;{$_('Le document est publié.')}</span>
                {/if}
            </div>
        </div>
    </div>
</div>
